export default __webpack_public_path__ + "static/media/google-play-badge.26b09a18.png";